import { PopoverContent, PopoverArrow, PopoverCloseButton, PopoverHeader, Heading, PopoverBody, PopoverFooter, Text, Box, Divider, VStack, } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { useTokens } from '../../../context/TokenProvider';
import AiAssistRatingWrapper from './AiAssistRatingWrapper';
import ExpandableContent from '../ExpandableContent/ExpandableContent';
import { RenderIf } from '../RenderIf/RenderIf';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
const AiAssistPopoverContent = ({ model, title, text, context, footer, }) => {
    const tokens = useTokens();
    const { isShare } = useInspectionDetailContext();
    const popoverRef = useRef(null);
    useEffect(() => {
        if (popoverRef.current) {
            const observer = new ResizeObserver(() => {
                window.dispatchEvent(new Event('resize'));
            });
            observer.observe(popoverRef.current);
            return () => observer.disconnect();
        }
        return undefined;
    }, []);
    const [isTextExpanded, setIsTextExpanded] = useState(true);
    const [isExpanded, setIsExpanded] = useState(false);
    const handleExpand = (expanded) => {
        setIsExpanded(expanded);
        setIsTextExpanded(!expanded);
    };
    return (React.createElement(PopoverContent, { ref: popoverRef, "data-testid": "ai_assist_popover_content", w: "lg", maxW: "90vw" },
        React.createElement(PopoverArrow, null),
        React.createElement(PopoverCloseButton, null),
        React.createElement(PopoverHeader, { border: "none" },
            React.createElement(Heading, { "data-testid": "ai_assist_popover_header", as: "h3", variant: "dk-800-md-5" }, title)),
        React.createElement(PopoverBody, null,
            React.createElement(VStack, { align: "start", spacing: tokens.Spacing04 },
                React.createElement(ExpandableContent, { showExpandText: isExpanded, isExpanded: isTextExpanded, handleExpandTextClicked: () => setIsTextExpanded(!isTextExpanded) },
                    React.createElement(Text, { "data-testid": "ai_assist_popover_body", whiteSpace: "pre-wrap", wordBreak: "break-word", variant: "md-600-rg-4" }, text)),
                React.createElement(RenderIf, { condition: !isShare },
                    React.createElement(AiAssistRatingWrapper, { handleExpand: handleExpand, type: "remoteSubmission", model: model, context: context })))),
        React.createElement(Box, { pt: tokens.Spacing02, px: tokens.Spacing04 },
            React.createElement(Divider, { variant: "grey" })),
        React.createElement(PopoverFooter, null,
            React.createElement(Text, { "data-testid": "ai_assist_popover_footer", variant: "lt-500-rg-5" }, footer))));
};
export default AiAssistPopoverContent;
